// @core/api/endpoints/form/get_form.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  FormResponse,
} from '../../../types/form';

const BASE_PATH = '/form';

/**
 * Get form by ID
 * Retrieves a form by its unique identifier including pages, fields, and settings.
 */
export async function GetForm(
  form_id: string,
  options?: RequestOptions
): Promise<FormResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/forms/:form_id`;
  requestPath = requestPath.replace(':form_id', encodeURIComponent(form_id));
  const requestOptions = options;
  return client.get<FormResponse>(requestPath, { ...requestOptions });
}
